import { Injectable } from '@angular/core';
import { MobileActivityExternalTask } from '@wdx/portal/api-models';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../libs/api-contract/base-api.service';

@Injectable()
export class ExternalTasksService extends BaseApiService {
    getTasks(): Observable<MobileActivityExternalTask[]> {
        return this._get<MobileActivityExternalTask[]>('externaltask');
    }

    submitTask(id: string): Observable<MobileActivityExternalTask> {
        return this.patch<MobileActivityExternalTask>(
            `externaltask/${id}/submit`,
            {},
        );
    }
}
